import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { autoCompleteV2, autoCompleteV2Skill, autoCompleteLocationV2 } from "../../actions/vacancies_actions";
import { Autocomplete, Typography, TextField, Box } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
// import ReactHtmlParser from "react-html-parser"

const jobMatchTypeOptions = [
  {
    label: "Previous",
    value: "Previous",
    htmlLabel: "Previous",
    group: "Job Match Options"
  },
  {
    label: "Preferred",
    value: "Preferred",
    htmlLabel: "Preferred",
    group: "Job Match Options"
  },
  {
    label: "Skills",
    value: "Skills",
    htmlLabel: "Skills",
    group: "Job Match Options"
  },
  {
    label: "Styles",
    value: "Styles",
    htmlLabel: "Styles",
    group: "Job Match Options"
  },
  {
    label: "Interests",
    value: "Interests",
    htmlLabel: "Interests",
    group: "Job Match Options"
  }
]

const blankOption = {
  label: "",
  value: "",
  htmlLabel: "",
  group: "Begin typing to search other occupations"
}

const whiteStyles = {backgroundColor: "white", color: 'black'}

export const EntitiesAutoComplete = ({
  onSelect,
  error,
  disabled,
  selectedOptions = [],
  size = "small",
  placeholder = "Begin typing to find occupations",
  type = "occupation",
  useJobMatchOption = false,
  blankInput,
  clearOnSelect=false
  }) => {
  const dispatch = useDispatch();
  const fontSize = size === "small" ? "0.8125rem" : "1rem"
  const [filteredOptions, setFilteredOptions] = useState(useJobMatchOption ? [...jobMatchTypeOptions, blankOption] : []); 
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchQueue, setSearchQueue] = useState("");

  const onInputChange = async (searchText) => {
    setLoading(searchText)
    setSearchQueue(searchText)
    if(searchText === ""){
      setFilteredOptions(useJobMatchOption ? [...jobMatchTypeOptions, blankOption] : [])
    }
    else{
      let response;
      if (type === "occupation") {
        response = await dispatch(autoCompleteV2(searchText));
      } else if (type === "skills") {
        response = await dispatch(autoCompleteV2Skill(searchText));
      } else {
        response = await dispatch(autoCompleteLocationV2(searchText));
      }
      if(response && (response.directMatches || response.closeMatches)){
        setFilteredOptions([...(useJobMatchOption ? jobMatchTypeOptions : []), ...response.directMatches, ...response.closeMatches])
      }
      else{
        setFilteredOptions([])        
      }
    }
    setLoading(false)
  };
  
  useEffect(() => {
    async function setBlankInput() {
      setInput("")
    }
    setBlankInput();
  }, [blankInput])

  useEffect(() => {
    async function autoCompleteHandeler() {
      if(!loading){
        if(input !== searchQueue){
          onInputChange(input);
        }
      }
    }
    autoCompleteHandeler()
  }, [input, loading, searchQueue, dispatch]);

  return (
      <Autocomplete
        style={useJobMatchOption ? whiteStyles : {}}
        fullWidth
        disabled={disabled}
        onInputChange={(event, searchText) => setInput(searchText)}
        onChange={(e, v) => {
          if(v){
            onSelect(v.label);
            if(clearOnSelect){
              setInput("")
            }
          }
        }}
        inputValue={input}
        options={filteredOptions}
        getOptionLabel={(option) => option.label}
        groupBy={(option) => option.group}
        renderInput={(params) => (
          <TextField 
            {...params}
            size="small"
            InputLabelProps={{...params.InputLabelProps, style: { fontSize:fontSize}}}
            InputProps={{...params.InputProps, style: { fontSize: fontSize}}}
            placeholder={placeholder}
            variant="outlined" 
            fullWidth 
            error={error}
            sx={{ '& .MuiOutlinedInput-root': { color:"black" } }}
          />
        ) 
        }
        renderOption={(props, option) => (
          <Typography 
            {...props}
            key={option.label}
            sx={{width: "100%", fontSize:fontSize, display:"flex", alignItems:"center", whiteSpace: "pre", display: "flex", justifyContent: "space-between"}} 
          >
              <Box component="span">
                {/* {ReactHtmlParser(option.htmlLabel)} */}
                {option.label}
              </Box>
            {selectedOptions.includes(option.label) && (<DoneIcon fontSize="small" style={{marginLeft:5}}/>)}
          </Typography>
          )
        }
        filterOptions={(options) => options}
      />
  );
};
